// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__Gy6Pn","footer":"ChangeClinic_footer__1eukw"};